// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceReportPage-cls1_Agw","cls2":"ReferenceReportPage-cls2_4Jk ReferenceReportPage-cls1_Agw"};